// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {apiBase} from '../../helpers/request';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import {fetchProjects, filter} from '../../actions/salesView';
import SelectFormInput from '../../components/SelectFormInput/SelectFormInput';

export type Props = {
  isFetching: boolean,
  fetchProjects: Function,
  filter: Function,
  projectId: ?number,
  projects: any[],
};

class SalesContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.fetchProjects();
  }

  render() {
    const {
      filter,
      isFetching,
      projects,
      projectId,
    } = this.props;

    return (
      <div className="SalesContainer relative">
        <LoadingIndicator isLoading={isFetching} />
        <div className="row align-middle">
          <div className="column">
            <SelectFormInput
              input={{
                value: projectId,
                onBlur: _.noop,
                onChange: project => filter(project ? project.id : null),
              }}
              placeholder="Välj projekt"
              meta={{}}
              valueKey="id"
              labelKey="name"
              multi={false}
              options={projects}
              clearable={false}
              isLoading={isFetching} />
          </div>
          {!!projects.length && !!projectId &&
            <div className="column shrink">
              <a
                href={`${apiBase}/dataexports/sales/${projectId}`}
                target="_blank"
                className="button success">
                Ladda ner
              </a>
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  salesView: {
    isFetching,
    projects,
    projectId,
  },
}) => ({
  isFetching,
  projects,
  projectId,
});

const mapDispatchToProps = dispatch => ({
  fetchProjects: () =>
    dispatch(fetchProjects()),
  filter: projectId =>
    dispatch(filter(projectId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesContainer);



// WEBPACK FOOTER //
// ./src/containers/SalesContainer/SalesContainer.js